import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	justify-content: space-between;
	main {
		flex: 1;
	}
`;
